module.exports = __webpack_public_path__ + "static/media/hoc1.761308a7.webp";